// POPIA backstop shared by both PWAs: nothing phone-shaped leaves the app, whatever
// path it took. Lives in one package precisely so the regex cannot drift between apps.
// ZA phone shapes: +27 / 27 / 0 prefix, then 9 digits with optional space/dash groups.
const ZA_PHONE = /(?:\+?27|0)[ -]?\d{2}[ -]?\d{3}[ -]?\d{4}/g;

export function scrubText(text: string): string {
  return text.replace(ZA_PHONE, "[phone]");
}

export function scrubDeep(value: unknown): unknown {
  if (typeof value === "string") return scrubText(value);
  if (Array.isArray(value)) return value.map(scrubDeep);
  // Object.entries/fromEntries only ever sees own enumerable string-keyed
  // properties, so any non-plain object (Date, Map, Error, a class instance) loses
  // its internal state and flattens to `{}` (or a plain object of just its own
  // enumerable props). That's fine for the JSON-shaped Sentry event/breadcrumb
  // payloads this is actually run over — it is not a general-purpose deep clone.
  if (value && typeof value === "object")
    return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, scrubDeep(v)]));
  return value;
}
